"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = exports.Layer = exports.EXPLORE_MODE_LABEL = exports.ExploreMode = exports.EXPLORE_FILTER_LABEL = exports.EXPLORE_FILTER_TO_BLOCK_TYPES = exports.ExploreFilter = exports.SupportedTheme = void 0;
const prisma_1 = require("@vienna/prisma");
var SupportedTheme;
(function (SupportedTheme) {
    SupportedTheme["light"] = "light";
    SupportedTheme["dark"] = "dark";
})(SupportedTheme = exports.SupportedTheme || (exports.SupportedTheme = {}));
// Filter codes you can use in the query
var ExploreFilter;
(function (ExploreFilter) {
    ExploreFilter["none"] = "none";
    ExploreFilter["text"] = "text";
    ExploreFilter["code"] = "code";
    ExploreFilter["file"] = "file";
    ExploreFilter["image"] = "image";
    ExploreFilter["embed"] = "embed";
})(ExploreFilter = exports.ExploreFilter || (exports.ExploreFilter = {}));
exports.EXPLORE_FILTER_TO_BLOCK_TYPES = {
    [ExploreFilter.none]: [],
    [ExploreFilter.text]: [prisma_1.BlockType.text],
    [ExploreFilter.code]: [prisma_1.BlockType.code],
    [ExploreFilter.file]: [prisma_1.BlockType.file],
    [ExploreFilter.image]: [prisma_1.BlockType.image],
    [ExploreFilter.embed]: [
        prisma_1.BlockType.linkEmbed,
        prisma_1.BlockType.spotifyEmbed,
        prisma_1.BlockType.youtubeEmbed,
        prisma_1.BlockType.twitterEmbed,
        prisma_1.BlockType.instagramEmbed,
    ],
};
// Block Types you can filter by
exports.EXPLORE_FILTER_LABEL = {
    [ExploreFilter.none]: "all",
    [ExploreFilter.text]: "text",
    [ExploreFilter.code]: "code",
    [ExploreFilter.file]: "file",
    [ExploreFilter.image]: "image",
    [ExploreFilter.embed]: "embed",
};
var ExploreMode;
(function (ExploreMode) {
    ExploreMode["random"] = "random";
    ExploreMode["recent"] = "recent";
})(ExploreMode = exports.ExploreMode || (exports.ExploreMode = {}));
exports.EXPLORE_MODE_LABEL = {
    [ExploreMode.random]: "Random",
    [ExploreMode.recent]: "Recent",
};
var Layer;
(function (Layer) {
    Layer[Layer["ROOT"] = 1] = "ROOT";
    Layer[Layer["TOPBAR"] = 2] = "TOPBAR";
    Layer[Layer["OVERLAY"] = 3] = "OVERLAY";
    Layer[Layer["WIN_LAYER"] = 99999] = "WIN_LAYER";
})(Layer = exports.Layer || (exports.Layer = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["Create"] = 0] = "Create";
    TransactionType[TransactionType["Delete"] = 1] = "Delete";
    TransactionType[TransactionType["Update"] = 2] = "Update";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
//# sourceMappingURL=enums.js.map